/**
 * Card — the standard white surface everything sits on.
 *
 * `interactive` adds a hover lift, for cards that are clickable (product
 * cards, category tiles). Static cards (an info panel) leave it off, so hover
 * feedback only appears where there is actually something to click.
 */

import { cn } from '@/lib/cn';

export function Card({ children, interactive = false, className, ...props }) {
  return (
    <div
      className={cn(
        'rounded-xl border border-line bg-surface shadow-card',
        interactive &&
          'cursor-pointer transition-all duration-200 hover:-translate-y-0.5 hover:shadow-hover',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
